<template>
    <div class="card-prestation" @click="handleCardClick" style="cursor: pointer;">
        <div class="form-check" :class="{checked: checked}">
            <span v-if="display_price && price" class="prest-prix">{{price}}{{currency}}</span>
            <input class="form-check-input" v-model="checked" style="pointer-events: none;" type="checkbox" value="" :id="'prestation-'+id">
            <label class="form-check-label" :for="'prestation-'+id" @click.prevent style="cursor: pointer;">
                <h5>{{title}}</h5>
                <!-- <h6 class="descrp-presta">{{text}}</h6> -->
                <h6 class="descrp-presta" v-if="text">
                <span :class="['desc-text', { expanded: descExpanded }]">{{ text }}</span>
                <button
                    v-if="isDescTruncated"
                    class="read-more-btn"
                    @click.stop="toggleDesc"
                >
                    {{ descExpanded ? 'Réduire' : 'Lire plus' }}
                </button>
                </h6>
                <h6 v-if="display_duration && duration">Durée: {{duration}} minutes</h6>
                <h6 v-if="enable_count_attendees" class="heading-count">Nombre de participants
                    <span class="counter-container" @click.stop>
                        <button @click.stop="decrease()" :disabled="this.attendees_nbre == 1">−</button>
                        <input type="text" id="count" class="count" :value="attendees_nbre" readonly>
                        <button @click.stop="increase()" :disabled="this.max_attendees != null && this.max_attendees <= this.attendees_nbre">+</button>
                    </span>
                </h6>
            </label>
        </div>
    </div>     
</template>

<script>
import { BookingStore } from '../Stores/BookingStore';

export default {
    name: 'CardPrestation',
    props: {
        id: {}, title: {}, text: {},
        display_duration: {}, duration: {}, 
        display_price: {}, price: {}, 
        enable_count_attendees: {}, 
        min_attendees: {},
        max_attendees: {},
        currency: {type: String, default: '€'},
        selected_prestations: [],
        group_size: null,
        selected: null,
        checked: null,
    },
    emits: ['selected','attendees_nbr'],

    data() {
        return {
            attendees_nbre: 1,
            descExpanded: false,
            isDescTruncated: false,
        }
    },

    methods: {
        handleCardClick(event) {
            // Émettre l'événement de sélection
            this.$emit('selected', !this.checked);
            
            // Si on vient de cocher et qu'il y a plus d'1 participant
            if (!this.checked && this.attendees_nbre > 1) {
                this.$emit('attendees_nbr', this.attendees_nbre);
            }
        },
        toggleDesc() {
            this.descExpanded = !this.descExpanded;
        },
        decrease() {
            if (!this.checked) {
                this.$emit('selected', true);
            }
            // Prevent to decrease if min reached
            if((this.min_attendees && this.attendees_nbre <= this.min_attendees) || this.attendees_nbre <= 1){
                return;
            }
            this.attendees_nbre--;
            this.$emit('attendees_nbr',this.attendees_nbre);
        },

        increase() {
            if (!this.checked) {
                this.$emit('selected', true);
            }
            // Prevent to increase if max set && max reached
            if(this.max_attendees != null && this.max_attendees <= this.attendees_nbre){
                return;
            }
            this.attendees_nbre++;
            this.$emit('attendees_nbr',this.attendees_nbre);
        },
        select(event){
            event.preventDefault();
            this.$emit('selected',this.checked)
            if (this.attendees_nbre > 1 && this.checked) {
                this.$emit('attendees_nbr',this.attendees_nbre);
            }
        }
    },
   mounted() {
        if (this.group_size > 1) {
            this.attendees_nbre = this.group_size;
        }
        this.$nextTick(() => {
            const span = this.$el.querySelector('.desc-text');
            if (span) {
            this.isDescTruncated = span.scrollHeight > span.clientHeight + 2;
            }
        });
}
}
</script>
<style>
.descrp-presta {
  margin: 0;
}

.desc-text {
  display: block;
  overflow: hidden;
  max-height: 3em;
  line-height: 1.5em;
  transition: max-height 0.3s ease;
}

.desc-text.expanded {
  max-height: 1000px;
}

.read-more-btn {
  display: none;
  background: none;
  border: none;
  color: var(--color-text-info, #567fac);
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  padding: 2px 0 0;
  margin: 0;
}


@media (max-width: 768px) {
  .read-more-btn {
    display: inline-block;
  }
}


@media (min-width: 769px) {
  .desc-text {
    max-height: none;
    overflow: visible;
  }
}
</style>